import React from 'react';
import PropTypes from 'prop-types';
import { CREATIVE_TYPE } from 'modules/campaigns/config';
import { ONLY_IMAGE_FILES } from 'modules/campaigns/modules/creative-creator/config/fileTypeConfigs';
import { MediaPicker } from 'modules/campaigns/modules/creative-editor/components/MediaPicker/MediaPicker';
import { useThumbnailEditorState } from 'modules/campaigns/modules/creative-editor/hooks/useThumbnailEditorState';
import { withIndication } from 'modules/errors';
import ThumbnailEditorImage from '../Image/ThumbnailEditorImage';
import styles from './thumbnailEditorBase.module.scss';

const ThumbnailEditorBase = ({ setIsThumbnailLoading, isThumbnailLoading, disabled }) => {
    const {
        error,
        thumbnailUrl,
        failedValidationData,
        scrollRef,
        selectedMedia,
        openCropModal,
        onSelectMedia,
        isThumbnailSelected,
    } = useThumbnailEditorState({
        isThumbnailLoading,
        setIsThumbnailLoading,
    });

    return (
        <MediaPicker
            fileTypes={ONLY_IMAGE_FILES}
            value={thumbnailUrl}
            onSelectMedia={onSelectMedia}
            disabled={disabled}
            tabsConditionData={{ creativeType: CREATIVE_TYPE.IMAGE }}
            tabsContext={{ thumbnails: selectedMedia }}
            showFileBrowser
            openCropModal={openCropModal}
        >
            <div className={styles['creative-editor']}>
                {isThumbnailSelected && (
                    <>
                        <ThumbnailEditorImage
                            imageSrc={thumbnailUrl}
                            isThumbnailLoading={isThumbnailLoading}
                            imageError={error}
                            disabled={disabled}
                            failedValidationData={failedValidationData}
                            scrollRef={scrollRef}
                            openCropModal={openCropModal}
                        />
                    </>
                )}
            </div>
        </MediaPicker>
    );
};

ThumbnailEditorBase.propTypes = {
    /* Creative object and handler to set new changes */
    creative: PropTypes.shape({
        thumbnailUrl: PropTypes.string,
        thumbnailFile: PropTypes.object,
        thumbnailRecommendedImage: PropTypes.shape({
            id: PropTypes.string,
        }),
    }),
    onUpdateCreative: PropTypes.func,
    /* Thumbnail loading flag and setter */
    isThumbnailLoading: PropTypes.bool,
    setIsThumbnailLoading: PropTypes.func,
    disabled: PropTypes.bool,
    uploadDescription: PropTypes.node,
};

export const ThumbnailEditorBaseWithIndication = withIndication(ThumbnailEditorBase);
